/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleSourceData } from './SingleSourceData';
import {
    SingleSourceDataFromJSON,
    SingleSourceDataFromJSONTyped,
    SingleSourceDataToJSON,
    SingleSourceDataToJSONTyped,
} from './SingleSourceData';
import type { StatisticsBySourceTopChannel1 } from './StatisticsBySourceTopChannel1';
import {
    StatisticsBySourceTopChannel1FromJSON,
    StatisticsBySourceTopChannel1FromJSONTyped,
    StatisticsBySourceTopChannel1ToJSON,
    StatisticsBySourceTopChannel1ToJSONTyped,
} from './StatisticsBySourceTopChannel1';

/**
 * 
 * @export
 * @interface StatisticsBySource
 */
export interface StatisticsBySource {
    /**
     * 
     * @type {StatisticsBySourceTopChannel1}
     * @memberof StatisticsBySource
     */
    topChannel1?: StatisticsBySourceTopChannel1 | null;
    /**
     * 
     * @type {StatisticsBySourceTopChannel1}
     * @memberof StatisticsBySource
     */
    topChannel2?: StatisticsBySourceTopChannel1 | null;
    /**
     * 
     * @type {StatisticsBySourceTopChannel1}
     * @memberof StatisticsBySource
     */
    topChannel3?: StatisticsBySourceTopChannel1 | null;
    /**
     * 
     * @type {StatisticsBySourceTopChannel1}
     * @memberof StatisticsBySource
     */
    otherChannels?: StatisticsBySourceTopChannel1 | null;
    /**
     * SingleSourceData>
     * @type {{ [key: string]: SingleSourceData; }}
     * @memberof StatisticsBySource
     */
    topMarketingChannelsWithoutOtherCategories?: { [key: string]: SingleSourceData; };
    /**
     * SingleSourceData>
     * @type {{ [key: string]: SingleSourceData; }}
     * @memberof StatisticsBySource
     */
    topOtherCategoriesChannels?: { [key: string]: SingleSourceData; };
}

/**
 * Check if a given object implements the StatisticsBySource interface.
 */
export function instanceOfStatisticsBySource(value: object): value is StatisticsBySource {
    return true;
}

export function StatisticsBySourceFromJSON(json: any): StatisticsBySource {
    return StatisticsBySourceFromJSONTyped(json, false);
}

export function StatisticsBySourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatisticsBySource {
    if (json == null) {
        return json;
    }
    return {
        
        'topChannel1': json['topChannel1'] == null ? undefined : StatisticsBySourceTopChannel1FromJSON(json['topChannel1']),
        'topChannel2': json['topChannel2'] == null ? undefined : StatisticsBySourceTopChannel1FromJSON(json['topChannel2']),
        'topChannel3': json['topChannel3'] == null ? undefined : StatisticsBySourceTopChannel1FromJSON(json['topChannel3']),
        'otherChannels': json['otherChannels'] == null ? undefined : StatisticsBySourceTopChannel1FromJSON(json['otherChannels']),
        'topMarketingChannelsWithoutOtherCategories': json['topMarketingChannelsWithoutOtherCategories'] == null ? undefined : (mapValues(json['topMarketingChannelsWithoutOtherCategories'], SingleSourceDataFromJSON)),
        'topOtherCategoriesChannels': json['topOtherCategoriesChannels'] == null ? undefined : (mapValues(json['topOtherCategoriesChannels'], SingleSourceDataFromJSON)),
    };
}

export function StatisticsBySourceToJSON(json: any): StatisticsBySource {
    return StatisticsBySourceToJSONTyped(json, false);
}

export function StatisticsBySourceToJSONTyped(value?: StatisticsBySource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'topChannel1': StatisticsBySourceTopChannel1ToJSON(value['topChannel1']),
        'topChannel2': StatisticsBySourceTopChannel1ToJSON(value['topChannel2']),
        'topChannel3': StatisticsBySourceTopChannel1ToJSON(value['topChannel3']),
        'otherChannels': StatisticsBySourceTopChannel1ToJSON(value['otherChannels']),
        'topMarketingChannelsWithoutOtherCategories': value['topMarketingChannelsWithoutOtherCategories'] == null ? undefined : (mapValues(value['topMarketingChannelsWithoutOtherCategories'], SingleSourceDataToJSON)),
        'topOtherCategoriesChannels': value['topOtherCategoriesChannels'] == null ? undefined : (mapValues(value['topOtherCategoriesChannels'], SingleSourceDataToJSON)),
    };
}

